import(/* webpackMode: "eager", webpackExports: ["HighlightInit"] */ "/home/runner/work/fanhearts.com/fanhearts.com/node_modules/@highlight-run/next/dist/next-client.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/fanhearts.com/fanhearts.com/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/fanhearts.com/fanhearts.com/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/fanhearts.com/fanhearts.com/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/fanhearts.com/fanhearts.com/src/components/analytics/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","GoogleTagManagerNoscript"] */ "/home/runner/work/fanhearts.com/fanhearts.com/src/components/analytics/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/fanhearts.com/fanhearts.com/src/config/i18n.ts");
